export function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
}

export function rgbToHex(r: number, g: number, b: number): string {
  return (
    "#" +
    [r, g, b]
      .map((x) => {
        const hex = x.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      })
      .join("")
  );
}

export function lightenColor(color: string, percent: number): string {
  const { r, g, b } = hexToRgb(color);
  const newR = Math.min(255, Math.floor(r * (1 + percent / 100)));
  const newG = Math.min(255, Math.floor(g * (1 + percent / 100)));
  const newB = Math.min(255, Math.floor(b * (1 + percent / 100)));
  return rgbToHex(newR, newG, newB);
}
